// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchInput_root__36qWl","input":"SearchInput_input__oev-p","searchIcon":"SearchInput_searchIcon__2yRhv"};